const languages = {
  EN: "en",
  ID: "id",
};

export { languages };
